import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { useGameAction } from 'src/hooks/useGameAction';
import { getMenuWidget } from 'src/services/cmsApi';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { CmsMenuWidgetItem } from 'src/types/cms/cmsWidgetTypes';
import { RootState } from 'src/types/store-types';
import './styles.scss';

const SideBarPromotion: FC = () => {
  const { locale } = useI18n();
  const [menuWidgetItems, setMenuWidgetItems] = useState<CmsMenuWidgetItem[] | null>(null);
  const { promotionAction, categoryAction, gameBoxAction, refFriendAction } = useBannerActions();
  const { handleActionGame } = useGameAction();

  const { sideBarMenuIsOpen } = useSelector((state: RootState) => state.app);

  useEffect(() => {
    let isMounted = true;

    getMenuWidget(locale).then((res) => {
      if (!isMounted || !res.success) return;

      const menuItems = res.result?.[0]?.content?.menuItems ?? [];
      if (menuItems.length) {
        setMenuWidgetItems(menuItems);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [locale]);

  const ctaAction = useCallback(
    (cta?: CmsCta): void => {
      if (!cta) return;

      switch (cta.variant) {
        case 'goToPromotion':
        case 'goToPromotions':
          promotionAction(cta?.param);
          return;
        case 'goToCategory':
          categoryAction(cta?.param);
          return;
        case 'goToGameBox':
          gameBoxAction();
          return;
        case 'goToRefFriend':
          refFriendAction();
          return;
        case 'goToGame':
          handleActionGame(cta?.param as number);
          break;
        case 'noAction':
          return;
        default:
          return;
      }
    },
    [categoryAction, promotionAction, gameBoxAction, refFriendAction]
  );

  const renderPromotionItems = (item: CmsMenuWidgetItem): JSX.Element => {
    const imageFromCms = sideBarMenuIsOpen ? item.imageDesktopOpened?.path : item.imageDesktopClosed?.path;
    return (
      <Button className="promotion-item" key={item.category} type="button" onClick={() => ctaAction(item.action)}>
        <img className="promotion-item__image" src={imageFromCms ?? ''} alt={item.category} />
      </Button>
    );
  };

  const itemsToRender = menuWidgetItems ?? [];
  if (!itemsToRender.length) return null;

  return (
    <div className="sidebar_promotion_section">
      {itemsToRender.map((promo: CmsMenuWidgetItem): JSX.Element => renderPromotionItems(promo))}
    </div>
  );
};

export default SideBarPromotion;
